(ns bp-libs.design-system.components.qr-code
  (:require [bp-libs.design-system.components.icons :refer [broken-image]]
            [qrcode-generator]))

(defn- code-number
  [number loading?]
  [:span {:class ["inline-flex p-6 bg-black mr-4 text-5xl rounded-lg"
                  (when loading? "animate-pulse dark-linear-gradient text-gray-700")]}
   number])

(defn- generate-qr-code
  "Generates the qr-code svg string"
  [url]
  (as-> url url-code
    (.createSvgTag
     (doto
      (qrcode-generator. 4 "L")
       (.addData url-code)
       (.make)) 7)))

(defn- broken-component
  [text]
  [:div {:class "text-gray-400 flex items-center"}
   [broken-image]
   [:span {:class "text-white"} text]])

(defn qr-code-component
  "@todo broken state vs loading"
  [url error?]
  (let [has-qr-code? (and url (seq url))]
    [:div {:class "space-y-6 flex flex-col"}
     (when-not has-qr-code?
       [:div {:class ["w-[18rem] h-[18rem] dark-linear-gradient drop-shadow flex items-center justify-center rounded-lg"
                      (when-not error? "animate-pulse")]}
        (when error?
          [broken-component "qrcode"])])
     (when has-qr-code?
       [:div {:class                   "qr-code"
              :dangerouslySetInnerHTML {:__html (generate-qr-code url)}}])]))

(defn code-component
  [code error?]
  (let [has-code? (seq code)]
    [:div {:class "font-bold space-y-4"}
     (if has-code?
       (doall
        (for [[key number] (zipmap (range 6) (seq code))]
          ^{:key key} [code-number number]))
       (if error?
         [:div {:class "w-full h-20 dark-linear-gradient flex items-center items-center justify-center text-sm font-normal rounded-lg"}
          [broken-component "code"]]
         (doall
          (for [[key number] (zipmap (range 6) "••••••")]
            ^{:key key} [code-number number true]))))]))
